<template>
  <v-dialog v-model="model" max-width="700" scrollable persistent opacity="0.65">
    <v-card>
      <v-form @submit.prevent="onSubmit">
        <v-card-title class="text-center">
          <h4 v-if="title"> {{ title }}</h4>
          <h4 v-if="type==='confirmation'" class="justify-center"> Confirm</h4>
        </v-card-title>
        <v-divider class="mx-4" />
        <v-card-text>
          <div v-if="type === 'confirmation' || type === 'confirmationTable'" class="swal2-icon swal2-question swal2-icon-show" style="display: flex;">
            <div class="swal2-icon-content">?</div>
          </div>
          <div class="d-flex flex-column align-center">
            <div class="text-h6 text-center">
              {{ questionContent }}
            </div>
          </div>
          <v-text-field
            v-if="type === 'text'"
            v-model="inputValue"
            :label="label"
            v-bind="inputValueAttrs"
          />
          <v-autocomplete
            v-if="type === 'select'"
            v-model="inputValue"
            :label="label"
            :items="items"
            :item-title="properties.itemTitle"
            v-bind="inputValueAttrs"
            return-object
          />
          <div v-if="type==='progress'" class="text-center">
            <v-progress-circular
              :size="50"
              color="primary"
              indeterminate
            />
            <h3>{{ messaage }}</h3>
          </div>
        </v-card-text>
        <v-card-actions v-if="type!=='progress'" class="d-flex">
          <div class="w-100 pr-1">
            <v-btn block color="error" variant="outlined" @click="cancel">{{ cancelText }}</v-btn>
          </div>
          <div class="w-100 pl-1">
            <v-btn block color="success" type="submit" variant="outlined">{{ confirmText }}</v-btn>
          </div>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script lang="ts" setup>
import { z } from 'zod'
import { toTypedSchema } from '@vee-validate/zod'
import type { PromptProperties } from '~/types/Reusable'

const model = ref(false)
const properties = defineProps<PromptProperties<Record<string, never>>>()
const { $eventBus } = useNuxtApp()
const rotateAnimation = ref(false)

onMounted(() => {
  model.value = true
  rotateAnimation.value = true
  setTimeout(() => rotateAnimation.value = false, 1000) // Reset after animation completes
})

const confirmText = computed(() => {
  if (properties.confirmText) {
    return properties.confirmText
  }
  return 'YES'
})

const cancelText = computed(() => {
  if (properties.cancelText) {
    return properties.cancelText
  }
  return 'CANCEL'
})
const questionContent = computed(() => properties.question)
const messaage = computed(() => properties.message)

const validationSchema = computed(() => {
  return z.object({
    inputValue: properties.rules ? properties.rules : z.string().optional(),
  })
})
const { defineField, handleSubmit, setFieldValue } = useForm({
  validationSchema: toTypedSchema(validationSchema.value),
  initialValues: {
    inputValue: properties.initialValue,
  },
})

const [inputValue, inputValueAttrs] = defineField('inputValue', VUETIFY_INPUT_CONFIG)

const onSubmit = handleSubmit((values) => {
  model.value = false
  $eventBus.emit('hide-prompt', {
    id: properties.id,
    value: properties.type === 'confirmation' ? true : values.inputValue,
  })
})

const cancel = () => {
  model.value = false
  $eventBus.emit('hide-prompt', {
    id: properties.id,
    cancelled: true,
  })
}

watch(
  () => properties.id,
  (_n, _o) => {
    setFieldValue('inputValue', properties.initialValue)
  }
)
</script>
